import { Classroom } from '@teetsh/app/src/types/classroom';
import getClassroomsGroupedByWorkingDays from '@teetsh/app/src/components/EDT/getClassroomsGroupedByWorkingDays';

export default function getClassroomsAvailableForThatDay(
  classrooms: Classroom[],
  d: number,
): Classroom[] {
  const groupedByWorkingDays = getClassroomsGroupedByWorkingDays(classrooms);
  return (groupedByWorkingDays[d] || [])
    .map(c => classrooms.find(cl => cl.id === c.id))
    .filter(c => c) as Classroom[];
}
